import { NgModule } from '@angular/core';

import { cpfValidatorDirective } from './directives/cpfValidator';
import { emailValidatorDirective } from './directives/emailValidator';
import { nameValidatorDirective } from './directives/nameValidator';
import { cpfCnpjValidatorDirective } from './directives/cpfCnpjValidator';
import { CpfCnpjMaskDirective } from './directives/cpfCnpjMask.directive';
import { NormalizeInputDirective } from './directives/textFormated';
import { PhoneMaskDirective } from './directives/appPhoneMask';
import { MaskDateDirective } from './directives/maskDateDirective';

@NgModule({
    imports: [],
    declarations: [
        cpfValidatorDirective,
        emailValidatorDirective,
        nameValidatorDirective,
        cpfCnpjValidatorDirective,
        CpfCnpjMaskDirective,
        NormalizeInputDirective,
        PhoneMaskDirective,
        MaskDateDirective
    ],
    exports: [
        cpfValidatorDirective,
        emailValidatorDirective,
        nameValidatorDirective,
        cpfCnpjValidatorDirective,
        CpfCnpjMaskDirective,
        NormalizeInputDirective,
        PhoneMaskDirective,
        MaskDateDirective
    ]
})
export class ValidatorsModule { }